module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-base-4.b064dc37.png";